import React, { useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import Model from "@tripian/model";
import ProgressBar from './ProgressBar';
import StepForm from './StepForm';

export type StepType = {
    id: number;
    title: string;
    isCompleted: boolean;
};

const TOTAL_STEPS = 8;

interface TripPlannerFormProps {
    editMode?: boolean;
    editTripHash?: string;
    editSegment?: Model.TimelineTripProfileSegment;
    editSegmentIndex?: number;
    existingSegmentCount?: number;
}

const TripPlannerForm: React.FC<TripPlannerFormProps> = ({
    editMode = false,
    editTripHash,
    editSegment,
    editSegmentIndex,
    existingSegmentCount,
}) => {
    const isValaiLanding = window.tconfig.LANDING_PAGE === "ValaiLanding";
    const [searchParams] = useSearchParams();
    const cityId = searchParams.get("cityId");
    const arrivalDate = searchParams.get("arrivalDate");
    const departureDate = searchParams.get("departureDate");
    const adults = searchParams.get("adults");
    const children = searchParams.get("children");

    // Always start from step 1, but data will be pre-filled from URL params
    // User can change any data they want
    const [currentStep, setCurrentStep] = useState(1);
    const [steps, setSteps] = useState<StepType[]>(
        Array.from({ length: TOTAL_STEPS }, (_, index) => ({
            id: index + 1,
            title: `Step ${index + 1}`,
            isCompleted: false,
        }))
    );

    const handleNext = () => {
        if (currentStep < TOTAL_STEPS) {
            setSteps(prevSteps =>
                prevSteps.map(step =>
                    step.id === currentStep ? { ...step, isCompleted: true } : step
                )
            );
            setCurrentStep(prev => prev + 1);
        }
    };

    const handleBack = () => {
        if (currentStep > 1) {
            setCurrentStep(prev => prev - 1);
        }
    };

    const progress = ((currentStep) / (TOTAL_STEPS)) * 100;

    return (
        <div className={`max-w-3xl mx-auto px-4${isValaiLanding ? " pt-13-h" : ""}`}>
            <ProgressBar 
                progress={progress} 
                currentStep={currentStep}
                totalSteps={TOTAL_STEPS}
            />
            
            <div className="mt-12">
                <StepForm
                    currentStep={currentStep}
                    onNext={handleNext}
                    onBack={handleBack}
                    isFirstStep={currentStep === 1}
                    isLastStep={currentStep === TOTAL_STEPS}
                    editMode={editMode}
                    editTripHash={editTripHash}
                    editSegment={editSegment}
                    editSegmentIndex={editSegmentIndex}
                    existingSegmentCount={existingSegmentCount}
                />
            </div>
        </div>
    );
};

export default TripPlannerForm;
